import React, { useEffect, useRef, useState } from "react";
import Layout from "../components/Layout";
import {
  API_URL,
  CHAT_URL,
  DEVICE_ID,
  ESP_URL,
  FAST_SPEED,
  JWT_TOKEN,
  MEDIUM_SPEED,
  SLOW_SPEED,
  VERYFAST_SPEED,
  WS_ESP_URL,
} from "./../constraints";
import { Canvas } from "@react-three/fiber";
import { CameraControls, Text } from "@react-three/drei";
import { Color, MeshStandardMaterial, SpotLight, TextureLoader } from "three";
import { useThree } from "@react-three/fiber";
import Typewriter from "typewriter-effect";
import { io } from "socket.io-client";
import CustomRaw from "../raw/CustomRaw";

import { useLoader } from "@react-three/fiber";
import { STLLoader } from "three-stdlib";
import buttonSTL from "./../assets/button.stl";
import { Mesh, MeshStandardMaterialParameters } from "three";

const socket = io(WS_ESP_URL, {
  transports: ["websocket"],
  auth: { token: JWT_TOKEN },
});

const GridFloor = () => {
  const { scene } = useThree();

  const brickTexture = new TextureLoader().load("./../../assets/brick.jpg");

  const brickMaterial = new MeshStandardMaterial({
    metalnessMap: brickTexture,
    roughness: 0.01,
  });

  useEffect(() => {
    const spotLight = new SpotLight("white", 10000);
    spotLight.position.set(0, 28, 0);
    spotLight.angle = Math.PI / 4;
    spotLight.penumbra = 0.05;
    spotLight.distance = 50;
    spotLight.castShadow = true;
    spotLight.shadow.mapSize.width = 512;
    spotLight.shadow.mapSize.height = 512;

    scene.add(spotLight);

    return () => {
      scene.remove(spotLight);
    };
  }, [scene]);

  return (
    <group>
      {/* Floor */}
      <mesh rotation={[-Math.PI / 2, 0, 0]} position={[0, -1, 0]} receiveShadow>
        <boxGeometry args={[70, 70]} />
        <meshStandardMaterial color={"#01022E"} />
      </mesh>
      {/* Left Wall */}
      <mesh position={[-34.5, 14, 0]} receiveShadow>
        <boxGeometry args={[1, 30, 70]} />
        <meshStandardMaterial color={"#7C0000"} />
      </mesh>
      {/* Right Wall */}
      <mesh position={[34.5, 14, 0]} receiveShadow>
        <boxGeometry args={[1, 30, 70]} />
        <meshStandardMaterial color={"#7C0000"} />
      </mesh>
      {/* Back Wall */}
      <mesh position={[0, 14, 34.5]} receiveShadow>
        <boxGeometry args={[70, 30, 1]} />
        <meshStandardMaterial color={"#7C0000"} />
      </mesh>
      {/* Roof */}
      <mesh position={[0, 29, 0]} receiveShadow>
        <boxGeometry args={[70, 1, 70]} />
        <meshStandardMaterial color={"gray"} />
      </mesh>

      {/* Lights on the roof */}
      <directionalLight
        position={[0, 28, 0]}
        castShadow
        color={"white"}
        visible={true}
        scale={[5, 5, 5]}
      />

      <directionalLight
        position={[0, 0, -15]}
        castShadow
        color={"gray"}
        visible={true}
        scale={[5, 5, 5]}
      />

      <directionalLight
        position={[-34.5, 14, 0]}
        castShadow
        color={"gray"}
        visible={true}
        scale={[5, 5, 5]}
      />

      <directionalLight
        position={[34.5, 14, 0]}
        castShadow
        color={"gray"}
        visible={true}
        scale={[5, 5, 5]}
      />

      <pointLight position={[-30, 28, -25]} intensity={50} color={"white"} />
      <pointLight position={[-20, 28, -25]} intensity={50} color={"white"} />
      <pointLight position={[-10, 28, -25]} intensity={50} color={"white"} />
      <pointLight position={[0, 28, -25]} intensity={50} color={"white"} />
      <pointLight position={[10, 28, -25]} intensity={50} color={"white"} />
      <pointLight position={[20, 28, -25]} intensity={50} color={"white"} />
      <pointLight position={[30, 28, -25]} intensity={50} color={"white"} />

      <pointLight position={[-30, 28, -15]} intensity={50} color={"white"} />
      <pointLight position={[-20, 28, -15]} intensity={50} color={"white"} />
      <pointLight position={[-10, 28, -15]} intensity={50} color={"white"} />
      <pointLight position={[0, 28, -15]} intensity={50} color={"white"} />
      <pointLight position={[10, 28, -15]} intensity={50} color={"white"} />
      <pointLight position={[20, 28, -15]} intensity={50} color={"white"} />
      <pointLight position={[30, 28, -15]} intensity={50} color={"white"} />

      <pointLight position={[-30, 28, -5]} intensity={50} color={"white"} />
      <pointLight position={[-20, 28, -5]} intensity={50} color={"white"} />
      <pointLight position={[-10, 28, -5]} intensity={50} color={"white"} />
      <pointLight position={[0, 28, -5]} intensity={50} color={"white"} />
      <pointLight position={[10, 28, -5]} intensity={50} color={"white"} />
      <pointLight position={[20, 28, -5]} intensity={50} color={"white"} />
      <pointLight position={[30, 28, -5]} intensity={50} color={"white"} />

      <pointLight position={[-30, 28, 5]} intensity={50} color={"white"} />
      <pointLight position={[-20, 28, 5]} intensity={50} color={"white"} />
      <pointLight position={[-10, 28, 5]} intensity={50} color={"white"} />
      <pointLight position={[0, 28, 5]} intensity={50} color={"white"} />
      <pointLight position={[10, 28, 5]} intensity={50} color={"white"} />
      <pointLight position={[20, 28, 5]} intensity={50} color={"white"} />
      <pointLight position={[30, 28, 5]} intensity={50} color={"white"} />

      <pointLight position={[-30, 28, 15]} intensity={50} color={"white"} />
      <pointLight position={[-20, 28, 15]} intensity={50} color={"white"} />
      <pointLight position={[-10, 28, 15]} intensity={50} color={"white"} />
      <pointLight position={[0, 28, 15]} intensity={50} color={"white"} />
      <pointLight position={[10, 28, 15]} intensity={50} color={"white"} />
      <pointLight position={[20, 28, 15]} intensity={50} color={"white"} />
      <pointLight position={[30, 28, 15]} intensity={50} color={"white"} />

      <pointLight position={[-30, 28, 25]} intensity={50} color={"white"} />
      <pointLight position={[-20, 28, 25]} intensity={50} color={"white"} />
      <pointLight position={[-10, 28, 25]} intensity={50} color={"white"} />
      <pointLight position={[0, 28, 25]} intensity={50} color={"white"} />
      <pointLight position={[10, 28, 25]} intensity={50} color={"white"} />
      <pointLight position={[20, 28, 25]} intensity={50} color={"white"} />
      <pointLight position={[30, 28, 25]} intensity={50} color={"white"} />
    </group>
  );
};

const LoadButtonOff = ({
  onClick,
  color,
}: {
  onClick: () => void;
  color: boolean;
}) => {
  const stlRef = useRef<Mesh | null>(null);

  const res = useLoader(STLLoader, buttonSTL);

  return (
    <mesh
      onClick={onClick}
      receiveShadow
      ref={stlRef}
      scale={[0.04, 0.04, 0.02]}
      position={[-7, 12.2, -2.2]}
      rotation={[0, 0, 0]}
    >
      <primitive object={res} />
      <meshStandardMaterial color={color ? "red" : "grey"} />
    </mesh>
  );
};
const LoadButtonOn = ({
  onClick,
  color,
}: {
  onClick: () => void;
  color: boolean;
}) => {
  // useFrame(() => {
  const stlRef = useRef<Mesh | null>(null);

  const res = useLoader(STLLoader, buttonSTL);

  return (
    <mesh
      onClick={onClick}
      receiveShadow
      ref={stlRef}
      scale={[0.05, 0.05, 0.02]}
      position={[-7.1, 12, -2.2]}
      rotation={[0, 0, 0]}
    >
      <primitive object={res} />
      <meshStandardMaterial color={color ? "green" : "red"} />
      <Text
        position={[0, -25, 0]}
        fontSize={15}
        color={color ? "green" : "red"}
        anchorX="center"
        anchorY="middle"
        rotation={[0, Math.PI, 0]}
      >
        {color ? "ON" : "OFF"}
      </Text>
    </mesh>
  );
};

const ParamScreen = ({
  params: { temperature, heat, frequency, humidity, count },
}: {
  params: {
    temperature: Number;
    heat: Number;
    humidity: Number;
    frequency: Number;
    count: Number;
  };
}) => {
  return (
    <mesh
      // position={[6.7, 3.55, 0.6]}
      position={[-0.5, 11.5, -2.2]}
      scale={[10, 2.5, 4]}
      rotation={[0, Math.PI, 0]}
    >
      <planeGeometry args={[1, 1]} />
      <meshStandardMaterial
        color="blue"
        attach="material"
        emissive="blue"
        emissiveIntensity={1}
      />
      <Text
        position={[0, 0.35, 0.1]}
        fontSize={0.1}
        color="white"
        anchorX="center"
        anchorY="middle"
        rotation={[Math.PI, Math.PI, Math.PI]}
      >
        Parameters
      </Text>
      <Text
        position={[0, 0.2, 0.1]}
        fontSize={0.08}
        color="white"
        anchorX="center"
        anchorY="middle"
        rotation={[Math.PI, Math.PI, Math.PI]}
      >
        {`Temperature: ${temperature} V`}
      </Text>
      <Text
        position={[0, 0.08, 0.1]}
        fontSize={0.08}
        color="white"
        anchorX="center"
        anchorY="middle"
        rotation={[Math.PI, Math.PI, Math.PI]}
      >
        {`Heat: ${heat} A`}
      </Text>
      <Text
        position={[0, -0.04, 0.1]}
        fontSize={0.08}
        color="white"
        anchorX="center"
        anchorY="middle"
        rotation={[Math.PI, Math.PI, Math.PI]}
      >
        {`Humidity: ${humidity} W`}
      </Text>
      <Text
        position={[0, -0.16, 0.1]}
        fontSize={0.08}
        color="white"
        anchorX="center"
        anchorY="middle"
        rotation={[Math.PI, Math.PI, Math.PI]}
      >
        {`Frequency: ${frequency} Hz`}
      </Text>
    </mesh>
  );
};

const CustomMachine = () => {
  const [isConnected, setIsConnected] = useState(true);
  const [enableAnimation, setEnableAnimation] = useState(true);
  const [animationSpeed, setAnimationSpeed] = useState(0.1);
  const [question, setQuestion] = useState("");
  const [output, setOutput] = useState(<></>);
  const [control, setControl] = useState(false);

  const [params, setParams] = useState({
    temperature: 0,
    heat: 0,
    frequency: 0,
    humidity: 0,
    count: 0,
  });

  const tempCard = useRef<HTMLDivElement>(null);
  const humidityCard = useRef<HTMLDivElement>(null);
  const heatCard = useRef<HTMLDivElement>(null);
  const frequencyCard = useRef<HTMLDivElement>(null);
  const countCard = useRef<HTMLDivElement>(null);
  const speedController = useRef<HTMLSelectElement>(null);
  const speedControllerText = useRef<HTMLSelectElement>(null);
  const speedControllerButton = useRef<HTMLButtonElement>(null);

  const handleSpeedChange = async (e: React.MouseEvent<HTMLButtonElement>) => {
    e.preventDefault();
    const value = speedController.current?.value;

    await fetch(`${ESP_URL}/speed-set`, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        Authorization: JWT_TOKEN,
      },
      body: JSON.stringify({
        speed: value,
      }),
    });
  };

  const submitHandler = async (e: React.MouseEvent<HTMLButtonElement>) => {
    e.preventDefault();

    setOutput(<></>);

    const response = await fetch(CHAT_URL, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
      },
      body: JSON.stringify({ question }),
    });

    const data = await response.json();

    if (data.intent === "getMachineStatus") {
      setOutput(
        <Typewriter
          onInit={(typewriter) => {
            typewriter
              .typeString(
                `Machine is currently ${
                  data.status ? "on" : "off"
                } with speed of ${data.speed} boxes/min !!`
              )
              .pauseFor(10)
              .start();
          }}
        />
      );
    } else if (data.intent === "getElectricParams") {
      setOutput(
        <Typewriter
          onInit={(typewriter) => {
            typewriter
              .typeString(
                `Parameters are: \n Temperature: ${data.temperature} C, Humidity: ${data.humidity} %, Heat: ${data.heat} C, Frequency: ${data.frequency} Hz ...`
              )
              .pauseFor(100)
              .start();
          }}
        />
      );
    } else if (data.intent === "switchOnMachine") {
      changeDeviceStatus(1);
      setOutput(
        <Typewriter
          onInit={(typewriter) => {
            typewriter
              .typeString("Machine is turned on !!")
              .pauseFor(100)
              .start();
          }}
        />
      );
    } else if (data.intent === "switchOffMachine") {
      changeDeviceStatus(0);
      setOutput(
        <Typewriter
          onInit={(typewriter) => {
            typewriter
              .typeString("Machine is turned off !!")
              .pauseFor(100)
              .start();
          }}
        />
      );
    } else {
      setOutput(
        <Typewriter
          onInit={(typewriter) => {
            typewriter.typeString("Invalid Query !!").pauseFor(100).start();
          }}
        />
      );
    }

    setQuestion("");
  };

  const changeDeviceStatus = async (status: number) => {
    if (status === 1) {
      setControl(true);
      setIsConnected(true);
      await fetch(`${ESP_URL}/switch-on`, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          Authorization: JWT_TOKEN,
        },
      });
    } else if (status === 0) {
      setControl(true);
      await fetch(`${ESP_URL}/switch-off`, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          Authorization: JWT_TOKEN,
        },
      });
    } else {
      setIsConnected(false);
      setControl(false);
      await fetch(`${ESP_URL}/leave-control`, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          Authorization: JWT_TOKEN,
        },
      });
    }
  };

  const updateData = async (message: any) => {
    if (message.switchStatus === 0) {
      setIsConnected(false);
    } else {
      setIsConnected(true);
    }

    setParams({
      temperature: message.temperature,
      heat: message.heat,
      frequency: message.frequency,
      humidity: message.humidity,
      count: message.count,
    });

    if (message.temperature !== undefined && tempCard.current !== null) {
      tempCard.current.innerText = message.temperature;
    }

    if (message.heat !== undefined && heatCard.current !== null) {
      heatCard.current.innerText = message.heat;
    }

    if (message.humidity !== undefined && humidityCard.current !== null) {
      humidityCard.current.innerText = message.humidity;
    }

    if (message.frequency !== undefined && frequencyCard.current !== null) {
      frequencyCard.current.innerText = message.frequency;
    }

    if (
      message.count !== undefined &&
      countCard.current !== null &&
      speedControllerButton.current !== null &&
      speedControllerText.current !== null
    ) {
      countCard.current.innerText = message.count;
      speedControllerButton.current.disabled = false;

      if (message.count === 0) {
        speedControllerText.current.innerHTML = "Machine is off";
        speedControllerButton.current.disabled = true;
      } else if (message.count <= 800) {
        speedControllerText.current.innerHTML = "Slow";
        setAnimationSpeed(SLOW_SPEED);
      } else if (message.count <= 2000) {
        speedControllerText.current.innerHTML = "Medium";
        setAnimationSpeed(MEDIUM_SPEED);
      } else {
        speedControllerText.current.innerHTML = "Fast";
        setAnimationSpeed(FAST_SPEED);
      }
    }
  };

  useEffect(() => {
    socket.on("deviceEvent", updateData);
  }, []);

  return (
    <Layout activeLink={"CustomMachine"}>
      <div className="container-fluid py-4">
        <div className="row">
          <div className="col-12">
            {control && (
              <div
                className="alert alert-danger"
                style={{ color: "black" }}
                role="alert"
              >
                <strong>Alerts !</strong> You have taken control of machine from
                the web. To enable manual switch{" "}
                <span
                  style={{ cursor: "pointer" }}
                  onClick={() => changeDeviceStatus(-1)}
                >
                  Click here !
                </span>
                .
              </div>
            )}
          </div>
          <div className="col-xl-7">
            <div
              className="card"
              style={{
                height: 500,
                backgroundColor: "#855141",
                borderBottomLeftRadius: 0,
                borderBottomRightRadius: 0,
              }}
            >
              <div className="card-body p-0 mt-2">
                <Canvas shadows camera={{ position: [0, 0, 15] }}>
                  <GridFloor />
                  <CustomRaw />
                  <ParamScreen params={params} />
                  <LoadButtonOn
                    onClick={() => changeDeviceStatus(isConnected ? 0 : 1)}
                    color={isConnected}
                  />
                  {/*                  
                  <RenderButton
                    onClick={() =>
                      !isConnected
                        ? changeDeviceStatus(1)
                        : changeDeviceStatus(0)
                    }
                    isConnected={isConnected}
                  /> */}

                  <CameraControls />
                  {/* <OrbitControls /> */}
                </Canvas>
              </div>
            </div>
          </div>
          <div className="col-xl-5 ms-auto mt-xl-0 mt-4">
            <div className="row">
              <div className="col-12">
                <div className="card">
                  <div className="card-body p-3">
                    <div className="row">
                      <div className="col-8 my-auto">
                        <div className="numbers">
                          <p className="text-sm mb-0 text-capitalize font-weight-bold opacity-7">
                            Description
                          </p>
                          <h5 className="font-weight-bolder mb-0">
                            3D Printed Machine
                          </h5>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div className="row mt-4">
              <div className="col-md-6">
                <div className="card">
                  <div className="card-body text-center">
                    <h1 className="text-gradient text-primary">
                      <span id="status1" ref={tempCard}>
                        N/A
                      </span>{" "}
                      <span className="text-lg ms-n2">C</span>
                    </h1>
                    <h6 className="mb-0 font-weight-bolder">Temperature</h6>
                  </div>
                </div>
              </div>
              <div className="col-md-6 mt-md-0 mt-4">
                <div className="card">
                  <div className="card-body text-center">
                    <h1 className="text-gradient text-primary">
                      {" "}
                      <span id="status2" ref={humidityCard}>
                        N/A
                      </span>{" "}
                      <span className="text-lg ms-n1">%</span>
                    </h1>
                    <h6 className="mb-0 font-weight-bolder">Humidity</h6>
                  </div>
                </div>
              </div>
            </div>
            <div className="row mt-4">
              <div className="col-md-6">
                <div className="card">
                  <div className="card-body text-center">
                    <h1 className="text-gradient text-primary">
                      <span id="status3" ref={heatCard}>
                        N/A
                      </span>{" "}
                      <span className="text-lg ms-n2">C</span>
                    </h1>
                    <h6 className="mb-0 font-weight-bolder">Heat</h6>
                  </div>
                </div>
              </div>
              <div className="col-md-6 mt-md-0 mt-4">
                <div className="card">
                  <div className="card-body text-center">
                    <h1 className="text-gradient text-primary">
                      <span id="status4" ref={frequencyCard}>
                        N/A
                      </span>{" "}
                      <span className="text-lg ms-n2">Hz</span>
                    </h1>
                    <h6 className="mb-0 font-weight-bolder">Frequency</h6>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div className="row mt-4" style={{ height: "300px" }}>
          <div className="col-lg-6 mt-lg-0 mt-4">
            <div className="row">
              <div className="col-sm-6">
                <div className="card h-100">
                  <div className="card-body p-3">
                    <h6>Usage</h6>
                    <div className="card h-100">
                      <div
                        className="card-body h-100 d-flex justify-content-center align-items-center"
                        style={{ flexDirection: "column" }}
                      >
                        <h1 className="text-gradient text-primary">
                          <span
                            style={{ fontSize: "80px" }}
                            id="status4"
                            ref={countCard}
                          >
                            N/A
                          </span>{" "}
                          <span className="text-lg ms-n2">packets</span>
                        </h1>
                        <h6 className="mb-0 font-weight-bolder">Count</h6>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <div className="col-sm-6 mt-sm-0 mt-4">
                <div className="card h-100">
                  <div className="card-body text-center p-3">
                    <h6 className="text-start">Machine Speed</h6>
                    <div className="card h-100 shadow">
                      <div className="card-body">
                        <form>
                          <div className="form-group">
                            <label></label>
                            <div className="row ps-3 pe-3">
                              <small
                                id="helpId"
                                className="form-text text-muted"
                                style={{ color: "white" }}
                              >
                                Current:{" "}
                                <span
                                  style={{ fontWeight: "bolder" }}
                                  ref={speedControllerText}
                                >
                                  0
                                </span>
                              </small>
                              <select
                                ref={speedController}
                                className="form-control"
                                placeholder="Speed"
                              >
                                <option value="0">Change speed</option>
                                <option value="-1">
                                  Control with the knob
                                </option>
                                <option value="25">Slow</option>
                                <option value="50">Medium</option>
                                <option value="100">Fast</option>
                              </select>
                              <button
                                type="submit"
                                className="btn mt-2  w-100 btn-dark"
                                onClick={handleSpeedChange}
                                ref={speedControllerButton}
                              >
                                Save
                              </button>
                            </div>

                            <small id="helpId" className="form-text text-muted">
                              Operate the machine according to the selected
                              speed.
                            </small>
                          </div>
                        </form>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div className="col-lg-6 mt-lg-0 mt-4">
            <div className="card h-100">
              <div className="card-body p-3">
                <h6>Query ?</h6>
                <div className="card shadow h-100">
                  <div className="card-body">
                    <form className="form-inline">
                      <div className="form-group py-0 my-0">
                        <div className="row px-2 py-0 my-0">
                          <div className="col-11 px-0">
                            <input
                              type="text"
                              name=""
                              id=""
                              className="form-control query-txt"
                              placeholder="Ask here !"
                              aria-describedby="helpId"
                              value={question}
                              onChange={(e) => setQuestion(e.target.value)}
                            />
                          </div>
                          <div className="col-1 ps-0 ">
                            <button
                              onClick={submitHandler}
                              type="submit"
                              className="w-100 px-0 mx-0 btn btn-dark query-btn"
                            >
                              <i
                                className="fa fa-chevron-right"
                                aria-hidden="true"
                              ></i>
                            </button>
                          </div>
                        </div>
                      </div>
                    </form>
                    <p className="p-0 m-0">
                      <b>Output:</b>
                      {output}
                      {/* <p dangerouslySetInnerHTML={{ __html: output }}></p> */}
                    </p>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <hr className="horizontal dark my-5" />
      </div>
    </Layout>
  );
};

export default CustomMachine;
